import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'

import httpService from '@services/httpService'

const DeleteMeasureDialog = ({ open, onCancel, deleteUrl, successUrl }) => {
  const [justification, setJustification] = useState('')
  const [error, setError] = useState(false)

  const confirm = () => {
    if (!justification.trim()) {
      setError(true)
      return
    }

    httpService
      .delete(deleteUrl, { data: { justification: justification.trim() } })
      .then(() => Turbolinks.visit(successUrl))
      .catch((e) => console.error('boom!', e))
  }

  const handleChange = (event) => {
    setJustification(event.target.value)
    if (error && event.target.value.trim()) setError(false)
  }

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth='sm'>
      <DialogTitle>{I18n.t('v4/equipment_measures.dialog.title')}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {I18n.t('v4/equipment_measures.dialog.text')}
        </DialogContentText>

        <TextField
          autoFocus
          fullWidth
          multiline
          rows={3}
          required
          margin='normal'
          variant='outlined'
          InputLabelProps={{ shrink: true }}
          label={I18n.t('v4/equipment_measures.dialog.justification_label')}
          placeholder={I18n.t('v4/equipment_measures.dialog.justification_placeholder')}
          value={justification}
          onChange={handleChange}
          error={error}
          helperText={error ? I18n.t('validations.required') : ''}
          inputProps={{ 'data-testid': 'delete-justification' }}
        />
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' onClick={onCancel}>
          {I18n.t('v4/delete_dialog.cancel')}
        </Button>

        <Button color='primary' variant='contained' onClick={confirm} data-testid='confirm-delete-measure'>
          {I18n.t('v4/delete_dialog.remove')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DeleteMeasureDialog.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  deleteUrl: PropTypes.string,
  successUrl: PropTypes.string
}

export default DeleteMeasureDialog
